// extracted by mini-css-extract-plugin
export default {"container":"doc_2EjzR"};